// 权限分配
const functionPrivilege: string =
  sessionStorage.getItem("functionPrivilege") || "[]";
const privileges: any = JSON.parse(functionPrivilege);
let role_menus: Array<[]> = privileges || [];
role_menus = role_menus.filter((item: any) => item);

export const checkPrivilege = (code: any) => {
  if (code && code.length && Array.isArray(code)) {
    return role_menus?.some((item: any) => {
      return code?.some((e: string) => item === e);
    });
  }
  return role_menus?.some((item: any) => item === code);
};

export { treeToArr, getTreeFirstValue } from "./tools";
